<div class="p-4">
  <div class="conainer">
    @if (loading) {
      <xos-loader [size]="'md'"></xos-loader>
    }
    @if (type === resourceType.IMAGE && !loading) {
      <img [src]="resource" class="w-full max-h-[80vh]" alt="">
    }
    @if (type === resourceType.VIDEO && !loading) {
      <video #video autoplay playsinline controls preload="metadata"
        class="w-full max-h-[80vh]">
        <source [src]="resource" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    }
  </div>
</div>